// Implements: F-VER-007, F-UIX-009, F-UIX-010
/**
 * The comparison of two versions of one mockup.
 *
 * Read-only and free, so it is an ordinary query. It stays idle while `left`
 * is `null`: nothing is asked until somebody has chosen what to compare with.
 */

import { useQuery } from "@tanstack/react-query";
import type { UseQueryResult } from "@tanstack/react-query";

import type { ApiError } from "../../../shared/api/ApiError";
import { versionDiffKey } from "../../../shared/api/queryKeys";
import type { VersionDiffView } from "../../../types/api";
import { compareVersions } from "../api/versionsApi";

export function useVersionDiff(
  mockupId: string,
  leftVersionId: string | null,
  rightVersionId: string,
): UseQueryResult<VersionDiffView, ApiError> {
  return useQuery<VersionDiffView, ApiError>({
    queryKey: versionDiffKey(mockupId, leftVersionId ?? "", rightVersionId),
    queryFn: () => compareVersions(mockupId, leftVersionId ?? "", rightVersionId),
    enabled: leftVersionId !== null,
  });
}
